export default __webpack_public_path__ + "static/media/Time_ClockDark.bcd6727f.svg";